import React from 'react'

export const useSnackbar = () => {
  const [isActive, setIsActive] = React.useState(false)
  const [message, setMessage] = React.useState('')
  const [isSuccess, setIsSuccess] = React.useState(true)

  React.useEffect(() => {
    if (isActive === true) {
      setTimeout(() => {
        setIsActive(false)
      }, 3000)
    }
  }, [isActive])

  const openSnackBar = (
    msg: string = 'Something went wrong...',
    status: boolean
  ) => {
    setIsSuccess(status)
    // Defensa: si algún caller pasa por error un objeto (ej. un evento de UI mal conectado
    // como handler), no lo dejamos llegar al render de <Typography>{message}</Typography>.
    setMessage(typeof msg === 'string' ? msg : 'Something went wrong...')
    setIsActive(true)
  }

  return { isActive, message, openSnackBar, isSuccess }
}
